import React from 'react';
import SecondImage from "../assets/PagingDrVedoPortfolioCover.jpg";

function About() {
  return (
    <section>
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2 ">
          {/* Left Column (Text and Buttons) */}
          <div className="flex flex-col items-start gap-2 md:py-14 md:px-14 max-w-[650px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-md uppercase mb-6">DID YOU KNOW?</p>
            </div>
            <h4 className="mb-2 text-3xl font-medium text-[#CFF098] md:text-5xl md:mb-2 font-storia">
           Your brand and website speak for you before you say a word.
            </h4>
             <h4 className="mb-6 text-[16px] font-semibold md:text-[20px] md:mb-4">
           ARE THEY SEALING THE DEAL OR SELLING YOU SHORT?
            </h4>
            <p className="text-sm text-white sm:text-xl">
           As a woman entrepreneur, you’re accustomed to wearing all the hats and juggling multiple responsibilities. It’s time to ensure your brand and website hustle just as hard as you do.
            </p>
            <div className="flex flex-col gap-4 font-regular sm:flex-row py-4">
              <a href="/about" className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-4 text-black hover:opacity-60  text-sm">
                <p className='uppercase'>DISCOVER YOUR BRAND POTENTIAL →</p>
              </a>
            </div>
          </div>

          {/* Right Column (Image) */}
          <div className="relative w-full">
          <a href='https://tierag19.sg-host.com'>
            <img
              src={SecondImage}
              alt="women using a laptop outdoors - Zilker Web Design"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;